import { ICustomInspectionTypeSettings } from '../../ICustomInspectionTypeSettings';
import { droneLabelScoreToColorCode } from './droneLabelScoreToColorCode';

const translation = {
    en: {
        droneLabel: {
            droneLabel: 'Drone label',
            label: 'Label',
            droneLabelResult: 'Results',
        },
        inspectionStandard: {
            droneLabel: 'Drone label',
        },
    },
    nl: {
        droneLabel: {
            droneLabel: 'Drone label',
            label: 'Label',
            droneLabelResult: 'Uitkomsten',
        },
        inspectionStandard: {
            droneLabel: 'Drone label',
        },
    },
};

export function conditionScoreToScore(conditionScore?: number | null | string) {
    if (conditionScore === undefined || conditionScore === null) {
        return null;
    }
    switch (conditionScore.toString()) {
        case '1':
            return 'A';
        case '2':
            return 'B';
        case '3':
            return 'C';
        case '4':
            return 'D';
        case '5':
            return 'E';
        case '6':
            return 'F';
        case '7':
            return 'G';
        default:
            return null;
    }
}

export function conditionScoreToColorCode(conditionScore?: number | null | string) {
    const score = conditionScoreToScore(conditionScore);
    return droneLabelScoreToColorCode(score);
}

export const droneLabelSettings: ICustomInspectionTypeSettings = {
    inspectionStandardType: 'droneLabel',
    translation,
    conditionScoreToScore,
    conditionScoreToColorCode,
};
